export interface ProductTypesStatisticsRow {
	ProductSize: string;
	PreparationHours: number | null;
	Billets: number | null;
	Tons: number | null;
	MillTimeHours: number | null;
	DelayTimeHours: number | null;
	TPH: number | null;
}

// The rollup row carries the literal the procedure itself assigns to a NULL ProductSize.
export const isTotalRow = (row: ProductTypesStatisticsRow): boolean =>
	row.ProductSize === "Total";
